<template>
    <modal name="update_make" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update make')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <make-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import MakesModelsService from '@services/makesModels.service';
import MakeForm from './components/MakeForm';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                name: null,
            },
            loading: false,
            make_id: null
        };
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    MakesModelsService.updateMake(this.make_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setMake', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const make = event.params.make;
            if (make) {
                this.form.name = make.name;
                this.make_id = make.id;
            }
        },
        hide() {
            this.$modal.hide('update_make');
        }
    },
    components: {
        MakeForm
    }
};
</script>
